/**
 * AgeCategoryCard — modern Bento-style subtab for the Growth page.
 *
 * Replaces the old emoji pill row with a grid of selectable cards.
 * The active card lights up with a gradient + glow so the currently
 * selected age category is unmissable.
 *
 *   <AgeCategoryCard
 *     tab={tab}
 *     active={tab.key === growthSubTab}
 *     onClick={() => setGrowthSubTab(tab.key)}
 *     autoSelected={tab.key === autoSelected}
 *   />
 *
 * `tab` shape: { key, label, range, icon, accent }
 */
import React from 'react';
import './AgeCategoryCard.css';

export function AgeCategoryCard({ tab, active, onClick, autoSelected = false, disabled = false }) {
    const { icon: Icon, label, range, accent = 'sky' } = tab;
    return (
        <button
            type="button"
            onClick={onClick}
            disabled={disabled}
            aria-pressed={active}
            className={`pt-age-card pt-age-card--${accent} ${active ? 'is-active' : ''} ${
                autoSelected ? 'is-auto' : ''
            }`}
        >
            <span className="pt-age-card__bg" aria-hidden="true" />
            <span className="pt-age-card__icon" aria-hidden="true">
                {Icon ? <Icon size={22} strokeWidth={2.25} /> : null}
            </span>
            <span className="pt-age-card__body">
                <span className="pt-age-card__label">{label}</span>
                <span className="pt-age-card__range">{range}</span>
            </span>
            {autoSelected ? (
                <span className="pt-age-card__auto" aria-label="Auto-selected based on age">
                    Auto
                </span>
            ) : null}
        </button>
    );
}

export default AgeCategoryCard;
